'use strict';

import {reverseUrl} from 'utils/django';

import state from './state';


export default function(incident) {
	state(incident);
	incident.phoneFromUrl =  reverseUrl('entities:jcw:after-hours:phone-number');
}
